import { Typography } from 'antd';
import { LinkButton } from 'src/components/CommonStyledComponents/CommonStyledComponents.styled';
import { HeaderTitleWrapper } from 'src/pages/People/Details/components/ActivityTab/components/InteractionMobile/InteractionMobile.styled';

import { ArrowLeftOutlined } from '@ant-design/icons';

import { PageHeader } from '../PageHeader/PageHeader';
import { MobileFullPageStyled } from './MobileFullPage.styled';

interface MobileFullPageProps {
  isOpen: boolean;
  onClose: () => void;
  headerTitle?: string;
  header?: React.ReactElement;
  headerChildren?: React.ReactElement;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const MobileFullPage = (props: MobileFullPageProps) => {
  const { isOpen, onClose, headerTitle, header, headerChildren, children, style } = props;

  return (
    <MobileFullPageStyled $isOpen={isOpen} style={style}>
      <PageHeader>
        <HeaderTitleWrapper $header={!!header}>
          {header ? (
            header
          ) : (
            <>
              <LinkButton
                data-testid="arrow-button"
                size="middle"
                onClick={onClose}
                type="link"
                icon={<ArrowLeftOutlined />}
              />
              <Typography.Title level={3}>{headerTitle}</Typography.Title>
            </>
          )}
        </HeaderTitleWrapper>
        {headerChildren || <></>}
      </PageHeader>
      {children}
    </MobileFullPageStyled>
  );
};

export default MobileFullPage;
